import React, { useState } from "react";
import { ApiEndpoint } from "../../utils/ApiEndpoint";
import { Stack } from "react-bootstrap";
import GenericAdminFilters from "./_GenericAdminFilters";
import AdminCampaignsSmsList from "./_AdminCampaignsSmsList";
import { MissInfoReport } from "../../components/MissInfo";
import { useAuth } from "../../Context/AuthContext";
import { httpClient } from "../../utils/HttpClient";

const ReportCampaignSmsAdmin = () => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [reportData, setReportData] = useState(null);
  const [periodStr, setPeriodStr] = useState(null);
  const [loading, setLoading] = useState(false);

  const getDataReport = (filters) => {
    setReportData(null);
    setLoading(true);
    const URI = ApiEndpoint + "administration/report/campaignssummary";

    httpClient(
      "POST",
      URI,
      {
        from: filters.dateFrom,
        to: filters.dateTo,
        customer: filters.idcustomer,
      },
      userData.token
    )
      .then(function (response) {
        setReportData(response.data);
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  return (
    <>
      <div className="">
        <Stack direction="horizontal" gap={2}>
          <div>
            <h2>Mensajes enviados por Campañas</h2>
            <h3>Consulte los mensajes enviados con base en la fecha.</h3>
          </div>
        </Stack>

        <div className="ReportDate">
          <GenericAdminFilters
            onRefresh={getDataReport}
            setPeriodStr={setPeriodStr}
            withStatusFilter={false}
            withPartnerFilter={false}
            withCarrierFilter={false}
            withShortCodeFilter={false}
            loading={loading}
          />
        </div>

        <nr />
        {reportData && reportData.length > 0 ? (
          <AdminCampaignsSmsList
            periodStr={periodStr}
            listMessages={reportData}
          ></AdminCampaignsSmsList>
        ) : (
          <MissInfoReport />
        )}
      </div>
    </>
  );
};

export default ReportCampaignSmsAdmin;
